import { useEffect } from 'react';

import { LOGOUT_EVENT } from '../constants/events';
import { useLogout } from './useLogout';

/**
 * Хук для синхронизации состояния между вкладками
 */
export const useSyncStorage = () => {
  const logout = useLogout();

  useEffect(() => {
    /**
     * Обработчик события изменения localStorage
     * @param event - Событие изменения хранилища
     */
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === LOGOUT_EVENT) {
        logout(false);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};
